import {Injectable} from "@angular/core";
import {HttpClient, HttpHandler} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {InitData} from "../../interfaces/visa-src/InitData";
import {InitiateIdentityValidationResponse} from "../../interfaces/visa-src/initiateIdentityValidationResponse";
import {SrcProfileReturns} from "../../interfaces/visa-src/SrcProfileReturns";
import {IsRecognizedResponse} from "../../interfaces/visa-src/IsRecognizedResponse";
import {ConsumerIdentityRequest} from "../../interfaces/visa-src/ConsumerIdentityRequest";
import {Checkout} from "../../interfaces/visa-src/Checkout";
import {VisaCheckoutResponse} from "../../interfaces/visa-src/VisaCheckoutResponse";
import {CompleteIdentityValidationResponse} from "../../interfaces/visa-src/CompleteIdentityValidationResponse";
import {IdentityLookupResponse} from "../../interfaces/visa-src/IdentityLookupResponse";
import {CompleteIdentityValidationRequest} from "../../interfaces/visa-src/CompleteIdentityValidationRequest";
import {SrcProfile} from "../../interfaces/visa-src/SrcProfile";
import {Card} from "../../interfaces/visa-src/Card";
import {SrcProfileRequest} from "../../interfaces/SrcProfileRequest";
import {VisaCheckoutEncodedResponse} from "../../interfaces/visa-src/VisaCheckoutEncodedResponse";

@Injectable()
export class ClickToPayApiClass extends HttpClient {
  private baseUrl = environment.production ? "/channel-virtual/api/v1" + '/click-to-pay' : environment.baseUrl + '/click-to-pay';


  constructor(
    private httpHandler: HttpHandler
  ) {
    super(httpHandler);
  }

  public initiateClickToPayPreemptive(initData: InitData, sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/initiate-preemptive/${sessionToken}`;
    return super.post(url, "");
  }

  public getEncryptedCardPayload(card: Card, sessionToken: string): Observable<any> {
    const url = `${this.baseUrl}/jwe/encryption/${sessionToken}`;
    return super.post(url, card);
  }

  public initializePayment(type, sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/initiate/${sessionToken}`;
    return super.post(url, type);
  }

  public checkSRCTdsRequired(sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/initiate/${sessionToken}`;
    return super.get(url);
  }

  // audit

  // audit requests

  public auditInitDataRequest(initData: InitData, sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/audit/init-request/${sessionToken}`;
    return super.post(url, initData);
  }

  public auditIdentityLookupRequest(identityLookup: ConsumerIdentityRequest, sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/audit/identity-lookup-request/${sessionToken}`;
    return super.post(url, identityLookup);
  }

  public auditSrcProfileRequest(srcProfileRequest: SrcProfileRequest, sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/audit/src-profile-request/${sessionToken}`;
    return super.post(url, srcProfileRequest);
  }

  public auditCompleteIdentityValidationRequest(completeIdentityValidationRequest: CompleteIdentityValidationRequest, sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/audit/complete-identity-validation-request/${sessionToken}`;
    return super.post(url, completeIdentityValidationRequest);
  }

  public auditCheckoutValidationRequest(checkout: Checkout, sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/audit/checkout-validation-request/${sessionToken}`;
    return super.post(url, checkout);
  }

  // audit responses

  public auditIsRecognizedResponse(isRecognizedResponse: IsRecognizedResponse, sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/audit/is-recognized-response/${sessionToken}`;
    return super.post(url, isRecognizedResponse);
  }

  public auditIdentityLookupResponse(identityLookupResponse: IdentityLookupResponse, sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/audit/identity-lookup-response/${sessionToken}`;
    return super.post(url, identityLookupResponse);
  }

  public auditIdentityValidationResponse(identityValidationResponse: InitiateIdentityValidationResponse, sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/audit/identity-validation-response/${sessionToken}`;
    return super.post(url, identityValidationResponse);
  }

  public auditSrcProfileResponse(srcProfileReturns: SrcProfileReturns, sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/audit/src-profile-response/${sessionToken}`;
    return super.post(url, srcProfileReturns);
  }

  public auditCompleteIdentityValidationResponse(completeIdentityValidationResponse: CompleteIdentityValidationResponse, sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/audit/complete-identity-validation-response/${sessionToken}`;
    return super.post(url, completeIdentityValidationResponse);
  }

  public auditCheckoutValidationResponse(checkoutResponse: VisaCheckoutEncodedResponse, sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/audit/checkout-validation-response/${sessionToken}`;
    return super.post(url, checkoutResponse);
  }


}
